import React from "react";
import { Redirect } from "react-router-dom";
import {
  PageSuspense,
  NoticeBoard,
  Downloads,
  Reports,
  ServiceDetail,
  SubCategoryDetail,
  CategoryDetail,
  Categories,
  MyProfile,
  FeedbackDetail,
  ChatPage,
  TermsAndConditions,
  BusinessNotification,
  BusinessCategoryTemplates,
  SamaiHomePage,
} from "../lazyComponents";
import { wrapHeavyFeaturePage } from "../heavyRouteBoundary";
import { SomethingWentWrong } from "../../components/error-pages";
import type { AppRoute } from "../types";

const serviceDetailRoute = wrapHeavyFeaturePage(
  () => (
    <PageSuspense>
      <ServiceDetail />
    </PageSuspense>
  ),
  "ServiceDetail"
);

export const reportsCategoriesProfileChatRoutes: AppRoute[] = [
  {
    path: "/notice-board",
    main: () => (
      <PageSuspense>
        <NoticeBoard />
      </PageSuspense>
    ),
  },
  {
    path: "/downloads",
    main: () => (
      <PageSuspense>
        <Downloads />
      </PageSuspense>
    ),
  },
  {
    path: "/reports",
    main: wrapHeavyFeaturePage(
      () => (
        <PageSuspense>
          <Reports />
        </PageSuspense>
      ),
      "Reports"
    ),
  },
  {
    path: "/categories/:categoryId/sub-categories/:subCategoryId/services/:serviceId",
    main: serviceDetailRoute,
  },
  {
    path: "/categories/:categoryId/sub-categories/:subCategoryId",
    main: () => (
      <PageSuspense>
        <SubCategoryDetail />
      </PageSuspense>
    ),
  },
  {
    path: "/categories/:categoryId/services/:serviceId",
    main: serviceDetailRoute,
  },
  {
    path: "/categories/:categoryId",
    main: () => (
      <PageSuspense>
        <CategoryDetail />
      </PageSuspense>
    ),
  },
  {
    path: "/categories",
    main: () => (
      <PageSuspense>
        <Categories />
      </PageSuspense>
    ),
  },
  {
    path: "/profile",
    main: () => (
      <PageSuspense>
        <MyProfile />
      </PageSuspense>
    ),
  },
  {
    path: "/feedback-detail/:ticketId",
    main: () => (
      <PageSuspense>
        <FeedbackDetail />
      </PageSuspense>
    ),
  },
  {
    path: "/feedback-detail",
    main: () => (
      <PageSuspense>
        <FeedbackDetail />
      </PageSuspense>
    ),
  },
  {
    path: "/chat",
    main: wrapHeavyFeaturePage(
      () => (
        <PageSuspense>
          <ChatPage />
        </PageSuspense>
      ),
      "Chat"
    ),
  },
  {
    path: "/TermsAndConditions",
    main: () => (
      <PageSuspense>
        <TermsAndConditions />
      </PageSuspense>
    ),
  },
  {
    path: "/notification",
    main: () => (
      <PageSuspense>
        <BusinessNotification />
      </PageSuspense>
    ),
  },
  {
    path: "/category-templates",
    main: () => (
      <PageSuspense>
        <BusinessCategoryTemplates />
      </PageSuspense>
    ),
  },
  {
    path: "/CategoryTemplates",
    main: () => <Redirect to="/category-templates" />,
  },
  {
    path: "HomePage",
    main: () => (
      <PageSuspense>
        <SamaiHomePage />
      </PageSuspense>
    ),
  },
  {
    path: "/something-went-wrong",
    main: () => <SomethingWentWrong />,
  },
];
